import { FeatureFlagT, useOrganizationEnabledFeatureFlagsQuery } from "../graphql/generated/graphql";

export const useFeatureFlag = (flag: FeatureFlagT): { enabled: boolean; loading: boolean } => {
  const { data, loading } = useOrganizationEnabledFeatureFlagsQuery();

  return {
    enabled: data?.organization?.enabledFeatureFlags?.includes(flag) || false,
    loading,
  };
};
